// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1Bzzz","upload":"Small_upload__UGxTD","imageWrap":"Small_imageWrap__TgZQv","removeBtn":"Small_removeBtn__2rnAB"};